import axios from "axios"

const BASE_URL = process.env.REACT_APP_API_URL

class CommonApi {
  getAllMetaData(config) {
    return axios.get(BASE_URL + "/cms/common/getAllMetaData", config)
  }

  getNotificationByUserId(config) {
    return axios.get(BASE_URL + "/cms/common/notifications", config)
  }

  getUserTypeCount(config){
  
    return axios.get(BASE_URL +"/admin/dashboard/getUserTypeCount",config)
  }

 
}

const commonApi = new CommonApi()
export default commonApi
